import { FivetranServiceEnum, shopifySchema } from "@repo/fivetran/types";

import {
  DestinationField,
  DestinationSetupField,
  SchemaField,
} from "./connection-fields";
import { ConnectionFormShell } from "./connection-form-shell";
import {
  type ConnectionFormProps,
  useConnectionForm,
} from "./use-connection-form";

/** Setup form for the Shopify Fivetran connector (Connect Card auth). */
export const ShopifyFormPage = ({
  onConnected,
  onCancel,
}: ConnectionFormProps = {}) => {
  const { form, embedded, formId } = useConnectionForm({
    service: FivetranServiceEnum.enum.shopify,
    schema: shopifySchema,
    defaultConfig: { schema: FivetranServiceEnum.enum.shopify },
    onConnected,
  });

  return (
    <ConnectionFormShell
      form={form}
      formId={formId}
      icon="shopify"
      submitLabel="Authenticate"
      embedded={embedded}
      onCancel={onCancel}
    >
      <DestinationField form={form} />
      <DestinationSetupField form={form} />
      <SchemaField form={form} />
    </ConnectionFormShell>
  );
};
